const orderDetail = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-detail.vue")), "order");
const orderSubmit = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-submit.vue")), "org");
const orderList = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-list.vue")), "order");
const orderMiddle = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-middle.vue")), "order");
const orderEvaluate = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-evaluate.vue")), "order");
const orderSubmitUnsubscribe = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-submit-unsubscribe.vue")), "order");
const orderSubmitSubscribe = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-submit-subscribe.vue")), "order");
const orderDetailUnsubscribe = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-detail-unsubscribe.vue")), "order");
const orderSuccessUnsubscribe = (resolve: any) => (<any>require).ensure([], () => resolve(require("src/views/order/order-success-unsubscribe.vue")), "order");




export default
[
    {
        path: "/order/detail/:id",
        name: "orderDetail",
        component: orderDetail,
        meta:
        {
            title: "体检订单详情",
            pageName:"GJ_体检订单详情"
        }
    },
    {
        path: "/order/submit",
        name: "submit-order",
        component: orderSubmit,
        meta:
        {
            title: "体检提交订单",
            pageName:"GJ_体检订单提交页"
        }
    },
    {
        path: "/order/middle",
        name: "orderMiddle",
        component: orderMiddle,
        meta:
        {
            title: "预约成功",
            pageName:"GJ_体检订单购买成功页"
        }
    },
    {
        path: "/order/list",
        name: "order-list",
        component: orderList,
        meta:
        {
            title: "我的订单",
            pageName: "GJ_订单列表"
        }
    },
    {
        path: "/order/evaluate/:id",
        name: "orderEvaluate",
        component: orderEvaluate,
        meta:
        {
            title: "我的订单"
        }
    },
    {
        path: "/order/submitUnsubscribe",
        name: "order-submit-unsubscribe",
        component: orderSubmitUnsubscribe,
        meta:
        {
            title: "提交订单",
            pageName:"GJ_订单提交页"
        }
    },
    {
        path: "/order/submitSubscribe",
        name: "order-submit-subscribe",
        component: orderSubmitSubscribe,
        meta:
        {
            title: "体检提交订单",
            pageName:"GJ_体检订单提交页"
        }
    },
    {
        path: "/order/detailUnsubscribe/:id",
        name: "order-detail-unsubscribe",
        component: orderDetailUnsubscribe,
        meta:
        {
            title: "体检订单详情",
            pageName:"GJ_体检订单详情"
        }
    },
    {
        path: "/order/successUnsubscribe",
        name: "order-success-unsubscribe",
        component: orderSuccessUnsubscribe,
        meta:
        {
            title: "预约成功",
            pageName:"GJ_体检订单购买成功页"
        }
    },
];
